import { AuthDriver as auth } from "auth";

export default {
  // called when the user attempts to log in
  login: ({ username, password }) => {
    if (auth.usesExternalFlow()) {
      return Promise.resolve();
    } else {
      return auth.attemptLogin({ username, password });
    }
  },
  // called when the user clicks on the logout button
  logout: async () => {
    auth.logout();
  },
  // called when the API returns an error
  checkError: async ({ status }) => {
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: async () => {
    const isUserLoggedIn = await auth.isUserLoggedIn();
    return isUserLoggedIn ? Promise.resolve() : Promise.reject();
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve()
};
